module.exports = __webpack_public_path__ + "static/media/fsyuce021.78adc0b9.jpg";